import { Config } from '@nw/shared/config';

import {
  AUTH_CODE,
  excludeQueryParams
} from '../../constants/clientBasedLoginConstant';

export const getRedirectionURLWithAuthCode = (
  clientInfo: {
    urlParams: URLSearchParams;
    redirectURL: string;
  },
  data: { code: string },
  hashString = ''
) => {
  const { urlParams, redirectURL } = clientInfo;
  const url = new URL(redirectURL);
  const params = new URLSearchParams(url.search.slice(1));
  params.set(AUTH_CODE, data.code);
  for (const [key, value] of urlParams.entries()) {
    if (!excludeQueryParams.includes(key)) {
      params.set(key, value);
    }
  }
  return `${url.origin}${url.pathname}?${params.toString()}${hashString}`;
};

export const getRedirectionURLWithOutAuthCode = (
  clientInfo: {
    urlParams: any;
    redirectURL: string;
  },
  hashString = ''
) => {
  const { urlParams, redirectURL } = clientInfo;
  const url = new URL(redirectURL);
  const params = new URLSearchParams(url.search.slice(1));
  for (const [key, value] of urlParams.entries()) {
    if (!excludeQueryParams.includes(key)) {
      params.set(key, value);
    }
  }
  return `${url.origin}${url.pathname}?${params.toString()}${hashString}`;
};

export const isValidCallBackURL = (url: string): boolean => {
  try {
    const hostname = new URL(url).hostname;
    const isValidCallBackURL = [
      'ccbp.academy',
      'nxtwave.academy',
      'nxtwave.careers',
      'niat.club',
      'nxtwavehire.co',
      'nxtwavetech.co',
      'studentdost.co',
      'dsaexpert.com',
      'niatglobal.com',
      'niatindia.com',
      'thepeoplefolks.com',
      'nxtwave.global',
      'ccbp.in',
      'nxtwave.co.in',
      'nxtwavetech.co.in',
      'collegedost.in',
      'earlywave.in',
      'monthint.in',
      'nxtwave.net.in',
      'niatglobal.in',
      'niatindia.in',
      'nxtwave.in',
      'nxtwavetechnologies.in',
      'ccbp.tech',
      'niat.tech',
      'niatglobal.tech',
      'nxtwave.tech',
      'nxtwavehire.tech',
      'topin.tech',
      'nxtwave.us',
      'niatindia.tech',
      'qa-audit-platform.lovable.app',
      'verify-nat.replit.app'
    ];
    const localDomains = ['localhost', 'nwtechdev.pagekite.me'];

    if (
      localDomains.includes(hostname) ||
      Config['ENVIRONMENT'] !== 'ccbp_prod'
    ) {
      return true;
    }

    return isValidCallBackURL.some((domain) => {
      return hostname === domain || hostname.endsWith('.' + domain);
    });
  } catch (error) {
    return false;
  }
};
